import { Box, Typography } from "@mui/material";

export default function PageNotFound() {
  return (
    <Box padding={4}>
      <Typography variant="h5">Page not found.</Typography>
    </Box>
  );
}

